(function () {
  // Selector matching all elixr-image-with-text section roots (one per instance).
  const ROOT_SELECTOR = '[data-elixr-image-with-text-config-id]';

  // Init function for scroll to first section functionality (Image with Text buttons)
  function initImageTextScrollToFirst() {
    try {
      // Handle scroll-to-first-section functionality for image with text buttons
      const scrollToFirstButtons = document.querySelectorAll('.image-text-scroll-to-first[data-scroll-to-first-section]');

      scrollToFirstButtons.forEach(button => {
        button.addEventListener('click', function (e) {
          e.preventDefault();


          // Find the first section on the page (excluding header/navigation)
          const selectors = [
            // Most common first section patterns
            'main section:first-of-type',
            '.main-content section:first-of-type',
            '.page-content section:first-of-type',

            // Shopify section patterns
            '.shopify-section:not([data-section-type="header"]):not([data-section-type="announcement-bar"])',
            'section.shopify-section:not([data-section-type="header"])',

            // General section patterns
            'main > *:first-child',
            '.content section:first-of-type',
            'section:not(header):not([role="banner"])',

            // Fallback to any section
            'section:first-of-type',
            '[data-section-type]:not([data-section-type="header"])',

            // Last resort - any content element
            'main > div:first-child',
            '.main > *:first-child'
          ];

          let targetElement = null;
          let usedSelector = '';

          for (const selector of selectors) {
            try {
              const elements = document.querySelectorAll(selector);
              if (elements.length > 0) {
                targetElement = elements[0];
                usedSelector = selector;
                break;
              }
            } catch (error) {
              console.warn(`❌ Invalid selector: ${selector}`, error);
            }
          }

          if (targetElement) {
            // Calculate offset for fixed headers
            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            const stickyHeader = document.querySelector('.sticky-header, .header-sticky, [style*="position: fixed"]')?.offsetHeight || 0;
            const adminBarHeight = document.querySelector('#admin_bar_iframe, .admin-bar')?.offsetHeight || 0;
            const announcementBar = document.querySelector('.announcement-bar, .promo-bar')?.offsetHeight || 0;

            const offset = Math.max(headerHeight, stickyHeader) + adminBarHeight + announcementBar + 20;

            const elementPosition = targetElement.offsetTop;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: 'smooth'
            });


            // Optional: Add visual highlight to show successful targeting
            targetElement.style.transition = 'all 0.3s ease';
            targetElement.style.transform = 'scale(1.01)';
            setTimeout(() => {
              targetElement.style.transform = 'scale(1)';
            }, 300);

          } else {
            console.warn('⚠️ Image with Text: No first section found, falling back to scroll to top');
            // Fallback: scroll to top if no target found
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });
      });
    } catch (error) {
      console.error('❌ Error initializing image with text scroll to first:', error);
    }
  }

  // Init function for scroll-to-top buttons (replaces external scrollToTop global)
  function initScrollToTop() {
    document.querySelectorAll('a[data-scroll-to-top="true"]').forEach(btn => {
      if (btn.dataset.scrollToTopBound === '1') return;
      btn.dataset.scrollToTopBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  // Init function for scroll to product functionality
  function initScrollToProduct() {
    try {
      // Handle smooth scrolling for product links
      const scrollButtons = document.querySelectorAll('.js-scroll-to-products, [data-scroll-to-product="true"]');

      if (scrollButtons.length === 0) return;

      scrollButtons.forEach(button => {
        button.addEventListener('click', function (e) {
          try {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            let targetElement = document.querySelector(targetId);

            if (targetElement) {
              // Scroll to the target element with smooth behavior
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            } else {
              // Try various common product section selectors if the specific ID wasn't found
              const productSelectors = [
                // Main product selectors
                '#MainProduct',
                '#shopify-section-product-template',
                '#shopify-section-product',
                '#product-section',
                '.product-section',
                // Fallback to any product-related elements
                '.product-template',
                '.product-container',
                '.product-main',
                '.product',
                '[data-section-type="product"]',
                '[data-section-id*="product"]'
              ];


              // Try each selector until we find a match
              for (const selector of productSelectors) {
                targetElement = document.querySelector(selector);
                if (targetElement) {
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                  return; // Exit once we've found and scrolled to a product element
                }
              }


              // Final fallback: if no product section is found, try scrolling to the main content area
              targetElement = document.querySelector('main') || document.querySelector('#MainContent');
              if (targetElement) {
                targetElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              } else {
              }
            }
          } catch (err) {
            console.error('Error in scroll button click handler:', err);
          }
        });
      });
    } catch (err) {
      console.error('Error initializing scroll to product functionality:', err);
    }
  }

  // Enhanced Accordion functionality with debugging
  function initAccordions() {
    const accordionContainers = document.querySelectorAll(ROOT_SELECTOR + ' .accordion-items-wrapper');

    if (accordionContainers.length === 0) {
      return;
    }

    accordionContainers.forEach((container, containerIndex) => {
      const accordionItems = container.querySelectorAll('.accordion-item');
      const accordionMode = container.getAttribute('data-accordion-mode') === 'true';

      accordionItems.forEach((item, itemIndex) => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');

        if (!header) {
          return;
        }

        if (!content) {
          return;
        }

        // Skip if already initialized
        if (header.hasAttribute('data-accordion-initialized')) {
          return;
        }


        // Create the click handler function
        const clickHandler = function (e) {
          e.preventDefault();
          e.stopPropagation();

          const isActive = item.classList.contains('active');

          // If in accordion mode, close all other items
          if (accordionMode && !isActive) {
            accordionItems.forEach((otherItem, otherIndex) => {
              if (otherItem !== item && otherItem.classList.contains('active')) {
                otherItem.classList.remove('active');
              }
            });
          }

          // Toggle the current item
          if (isActive) {
            item.classList.remove('active');
          } else {
            item.classList.add('active');
          }

          // Trigger custom event for tracking/analytics
          try {
            container.dispatchEvent(new CustomEvent('accordion:toggle', {
              detail: {
                item: item,
                isOpen: !isActive,
                text: header.querySelector('.accordion-header-text')?.textContent
              }
            }));
          } catch (err) {
            console.error('Error dispatching accordion event:', err);
          }
        };

        // Add the click listener
        header.addEventListener('click', clickHandler);

        // Store the handler reference for potential cleanup
        header._accordionClickHandler = clickHandler;

        // Mark as initialized
        header.setAttribute('data-accordion-initialized', 'true');

        // Add visual feedback on hover
        header.style.cursor = 'pointer';

        // Add keyboard support
        const keyHandler = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            clickHandler(e);
          }
        };

        header.addEventListener('keydown', keyHandler);
        header._accordionKeyHandler = keyHandler;

        // Make header focusable for accessibility
        if (!header.hasAttribute('tabindex')) {
          header.setAttribute('tabindex', '0');
        }

      });
    });

  }

  // Function to manually test accordion (for debugging)
  function testAccordion() {
    const firstItem = document.querySelector(ROOT_SELECTOR + ' .accordion-item');
    if (firstItem) {
      firstItem.classList.toggle('active');
      return true;
    } else {
      return false;
    }
  }

  // Initialize immediately if DOM is already ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initImageTextScrollToFirst();
      initScrollToProduct();
      initAccordions();
      initScrollToTop();
    });
  } else {
    // DOM is already ready
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
    initScrollToTop();
  }

  // Also run on window load to ensure all elements are fully loaded
  window.addEventListener('load', function () {
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
    initScrollToTop();
  });

  // Additional initialization for dynamic content
  document.addEventListener('shopify:section:load', function () {
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
    initScrollToTop();
  });

  // Backup initialization using setTimeout
  setTimeout(function () {
    if (document.querySelector(ROOT_SELECTOR + ' .accordion-items-wrapper') && !document.querySelector(ROOT_SELECTOR + ' .accordion-header[data-accordion-initialized]')) {
      initAccordions();
      initScrollToTop();
    }
  }, 2000);

  // Make functions globally available for debugging
  window.debugAccordion = {
    init: initAccordions,
    test: testAccordion,
    toggle: function (index) {
      const items = document.querySelectorAll(ROOT_SELECTOR + ' .accordion-item');
      if (items[index]) {
        items[index].classList.toggle('active');
      }
    }
  };

  // Final fallback: try to initialize immediately
  try {
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
    initScrollToTop();
  } catch (err) {
    console.error('Immediate initialization failed:', err);
  }
})();
